import { IExamMasterCodeItem } from '../../../api/user/model';

export const DROPDOWN_PLACEHOLDER = undefined;

export const getIExamDropdownItemLabel = (option: IExamMasterCodeItem) =>
  option.codeValueDescription || '';

export const getIExamMasterCodeSelected = (
  option: IExamMasterCodeItem,
  value: IExamMasterCodeItem
) => option.codeId === value.codeId;
